export const SAVE_BACKTEST_TYPE = {
  SAVE: 'save',
  SAVE_AND_ADD_ANOTHER: 'save_and_add_another',
};